var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTablePlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 158,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m122.819 139.815-5.337 4.914 4.242-7.117c-3.342-6.061-8.808-11.299-8.808-11.299s-11.34 10.865-11.34 19.405c0 8.54 5.077 11.522 11.34 11.522s11.34-2.982 11.34-11.522c0-1.901-.563-3.917-1.437-5.903Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.111 144.996v.421c-.025 4.893-.851 8.711-2.47 11.399-.023.04-.048.078-.071.117l-.181-.11-.173-.109c1.796-2.903 2.432-7.006 2.455-11.274.002-.137.004-.277.002-.417a56.758 56.758 0 0 0-.294-5.409c-.012-.138-.027-.278-.041-.417a83.692 83.692 0 0 0-1.042-6.936c-.628-3.288-1.267-5.67-1.413-6.197l-.029-.109.197-.056.003-.002.2-.056c.002.008.037.127.095.348.223.825.803 3.065 1.372 6.02l.077.409c.296 1.577.585 3.34.815 5.191.058.465.11.923.156 1.375a57.082 57.082 0 0 1 .342 5.812Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.72 132.207a11.528 11.528 0 0 1-1.6.112 11.174 11.174 0 0 1-4.835-1.091l-.264.333a11.596 11.596 0 0 0 5.099 1.175c.419 0 .838-.022 1.254-.066.142-.015.284-.034.423-.055a11.475 11.475 0 0 0 3.324-1.006l-.262-.338c-.995.465-2.052.78-3.139.936ZM115.767 139.182a6.914 6.914 0 0 1-.431.013c-.044.002-.09.002-.134.002-1.813 0-3.598-.438-5.205-1.278a11.23 11.23 0 0 1-4.022-3.542c-.084.123-.167.246-.248.371a11.655 11.655 0 0 0 9.475 4.866c.059 0 .117 0 .175-.002a11.599 11.599 0 0 0 6.613-2.18 33.74 33.74 0 0 0-.203-.369 11.159 11.159 0 0 1-6.02 2.119Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.109 144.996a12.28 12.28 0 0 1-.906.038 11.276 11.276 0 0 1-10.808-8.111c-.093.169-.187.335-.277.504a11.683 11.683 0 0 0 11.991 7.99 11.654 11.654 0 0 0 7.69-3.753c-.044-.154-.094-.307-.144-.461a11.233 11.233 0 0 1-7.546 3.793Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.356 55.55c15.108 0 27.355-12.247 27.355-27.355C54.711 13.086 42.464.838 27.356.838 12.247.839 0 13.086 0 28.195 0 43.303 12.248 55.55 27.356 55.55Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.357 50.99c12.59 0 22.796-10.207 22.796-22.797S39.947 5.396 27.357 5.396 4.56 15.603 4.56 28.193s10.206 22.796 22.796 22.796Z",
    fill: "#003BB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 55.55c15.108 0 27.356-12.247 27.356-27.355C127.356 13.086 115.108.838 100 .838c-15.108 0-27.356 12.247-27.356 27.356 0 15.108 12.248 27.355 27.356 27.355Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.999 50.99c12.59 0 22.796-10.207 22.796-22.797S112.589 5.396 99.999 5.396 77.202 15.603 77.202 28.193 87.408 50.989 100 50.989Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.645 55.55C187.753 55.55 200 43.303 200 28.195 200 13.086 187.753.838 172.645.838s-27.356 12.247-27.356 27.356c0 15.108 12.248 27.355 27.356 27.355Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.643 50.99c12.59 0 22.796-10.207 22.796-22.797S185.233 5.396 172.643 5.396s-22.796 10.207-22.796 22.797 10.206 22.796 22.796 22.796ZM25.42 36.438a2.5 2.5 0 0 1-1.979-.968l-3.496-4.495a2.508 2.508 0 0 1 .439-3.516l.126-.098a2.508 2.508 0 0 1 3.515.44 2.23 2.23 0 0 0 3.377.164l7.1-7.495a2.504 2.504 0 0 1 3.542-.096l.116.11a2.506 2.506 0 0 1 .096 3.541l-11.018 11.63a2.503 2.503 0 0 1-1.819.782Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.995 22.654H69.989V6.994a3.663 3.663 0 0 1 3.722-3.592h5.986c4.575 0 8.298 3.593 8.298 8.01v11.242Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.66 153.689h-3.418l-1.627-13.184h5.045v13.184Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.531 157.003-11.021-.001v-.139a4.288 4.288 0 0 1 4.29-4.29l6.732.001v4.429Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.154 153.689h-3.419l-1.626-13.184h5.045v13.184Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.025 157.003-11.022-.001v-.139a4.288 4.288 0 0 1 4.29-4.29l6.732.001v4.429Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.28 47.769-2.23 14.219 21.19.279-2.789-13.662-16.17-.836Z",
    fill: "#9E616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.665 58.518-6.749 17.97-.836 74.471h5.716l13.661-59.834 12.547 58.272h5.576l-3.903-65.52s1.15-13.152-4.74-20.912l-1.434-4.142-19.838-.305Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.615 72.526a4.182 4.182 0 0 1-2.68-5.828L82.921 37.31l6.63-1.315 8.245 28.807a4.206 4.206 0 0 1-3.18 7.724Z",
    fill: "#9E616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.686 55.622-14.607-.282a1.91 1.91 0 0 1-1.81-1.439c-.782-3.1-2.505-11.18-1.592-19.227a11.734 11.734 0 0 1 13.34-10.266 11.742 11.742 0 0 1 9.691 14.604c-1.838 6.983-2.877 11.978-3.087 14.848a1.906 1.906 0 0 1-1.935 1.762Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.316 29.807c.088.197.16.4.215.609l18.284 6.212 3.532-3.086 5.355 4.723-5.723 6.071a3.114 3.114 0 0 1-3.684.638L36.731 34.98a4.087 4.087 0 1 1 1.585-5.173Z",
    fill: "#9E616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.854 35.638a1.75 1.75 0 0 1 .615-1.322l6.695-5.703a4.867 4.867 0 0 1 7.348 6.38l-4.767 7.424a1.752 1.752 0 0 1-2.627.373l-6.665-5.821a1.75 1.75 0 0 1-.6-1.33ZM82.515 44.752a1.751 1.751 0 0 1-.89-1.155l-1.98-8.569a4.866 4.866 0 0 1 9.048-3.585l4.394 7.65a1.752 1.752 0 0 1-.878 2.504l-8.237 3.236a1.75 1.75 0 0 1-1.457-.08Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.602 4.932c.676-1.583-.487-3.598-2.598-4.5-2.111-.901-4.37-.349-5.047 1.234-.676 1.584.487 3.598 2.598 4.5 2.11.902 4.37.35 5.047-1.234Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.053 16.702a8.525 8.525 0 1 0-14.96-8.178 8.525 8.525 0 0 0 14.96 8.178Z",
    fill: "#9E616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.25 2.848h-9.751a2.833 2.833 0 0 0-2.86 2.586 2.77 2.77 0 0 0 2.765 2.954 2.77 2.77 0 0 1 2.77 2.77v11.357H88.41V11.008a8.16 8.16 0 0 0-8.16-8.16Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.318 157.419H22.778a.277.277 0 1 1 0-.554h105.54a.276.276 0 0 1 .196.473.276.276 0 0 1-.196.081Z",
    fill: "#CACACA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h200v157.419H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablePlaceholder);
export default __webpack_public_path__ + "static/media/table-placeholder.f1eba61c2653e73da956dd7eb3ad3660.svg";
export { ForwardRef as ReactComponent };